var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.9978,
    height: 41.9978,
    fill: "#D4AF37",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 41.4978,
    height: 41.4978,
    stroke: "#C9B99B",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9993 10.9998V14.9998",
    stroke: "#F0E1CE",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9985 10.9998V14.9998",
    stroke: "#F0E1CE",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9983 12.9996H13.9996C12.8951 12.9996 11.9998 13.895 11.9998 14.9995V28.9982C11.9998 30.1026 12.8951 30.998 13.9996 30.998H27.9983C29.1028 30.998 29.9981 30.1026 29.9981 28.9982V14.9995C29.9981 13.895 29.1028 12.9996 27.9983 12.9996Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 18.9991H29.9981",
    stroke: "#F0E1CE",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticon02);
export default __webpack_public_path__ + "static/media/staticon02.88cc7297f2f9304014f8356ffd75435e.svg";
export { ForwardRef as ReactComponent };